import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { listStoreSalaryStatements } from '../../../services/storeSalaryStatementApi';
import '../../../assets/styles/salaryStatement.css';

const empty = { page: 1, limit: 20, total: 0, totalPages: 0, hasNext: false, hasPrev: false };

export default function StoreSalaryStatementList() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [appliedSearch, setAppliedSearch] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [limit] = useState(20);
  const [pagination, setPagination] = useState(empty);
  const loadingRef = useRef(false);

  const load = useCallback(async ({ nextPage = 1, nextSearch = '', nextMonth = '', nextYear = '' } = {}) => {
    if (loadingRef.current) return;

    loadingRef.current = true;
    setLoading(true);
    setErr('');

    try {
      const r = await listStoreSalaryStatements({ page: nextPage, limit, search: nextSearch, month: nextMonth, year: nextYear });
      setRows(r.data?.items || []);
      setPagination(r.data?.pagination || { ...empty, page: nextPage, limit });
    } catch (e) {
      setErr(e.message);
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    load({ nextPage: 1, nextSearch: '', nextMonth: '', nextYear: '' });
  }, [load]);

  const apply = () => {
    const value = search.trim();
    setAppliedSearch(value);
    load({ nextPage: 1, nextSearch: value, nextMonth: month, nextYear: year });
  };

  const clear = () => {
    setSearch('');
    setAppliedSearch('');
    setMonth('');
    setYear('');
    load({ nextPage: 1, nextSearch: '', nextMonth: '', nextYear: '' });
  };

  const go = p => {
    if (loading || p < 1 || p > pagination.totalPages) return;

    load({ nextPage: p, nextSearch: appliedSearch, nextMonth: month, nextYear: year });
  };

  return <div><h2>Salary Statements</h2>{err && <div className="alert alert-danger">{err}</div>}<div className="store-card p-3 mb-3"><div className="row g-2 align-items-end"><div className="col-md-5"><label className="form-label">Search</label><input className="form-control" placeholder="Search salary statement" value={search} disabled={loading} onChange={e => setSearch(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') apply(); }} /></div><div className="col-md-2"><label className="form-label">Month</label><input className="form-control" value={month} disabled={loading} onChange={e => setMonth(e.target.value)} /></div><div className="col-md-2"><label className="form-label">Year</label><input className="form-control" value={year} disabled={loading} onChange={e => setYear(e.target.value)} /></div><div className="col-auto"><button className="btn btn-primary" disabled={loading} onClick={apply}>Search</button></div><div className="col-auto"><button className="btn btn-outline-secondary" disabled={loading} onClick={clear}>Clear</button></div></div></div><div className="store-card table-responsive"><table className="table"><thead><tr><th>Title</th><th>Month/Year</th><th>Uploaded</th><th>Total Rows</th><th>Action</th></tr></thead><tbody>{loading ? <tr><td colSpan="5" className="text-center py-4"><span className="spinner-border spinner-border-sm me-2" />Loading...</td></tr> : rows.length ? rows.map(r => <tr key={r.id}><td>{r.title || 'Salary Statement'}</td><td>{r.month}/{r.year}</td><td>{r.uploadedAt ? new Date(r.uploadedAt).toLocaleDateString() : ''}</td><td>{r.totalRows}</td><td><Link className="btn btn-sm btn-primary" to={`/store/salary-statements/${r.id}`}>Preview</Link></td></tr>) : <tr><td colSpan="5" className="text-center py-4">No salary statements found</td></tr>}</tbody></table><div className="d-flex justify-content-between align-items-center p-3"><span>Page {pagination.page} of {pagination.totalPages || 0}</span><div><button className="btn btn-outline-secondary me-2" disabled={loading || !pagination.hasPrev} onClick={() => go(pagination.page - 1)}>Previous</button><button className="btn btn-outline-secondary" disabled={loading || !pagination.hasNext} onClick={() => go(pagination.page + 1)}>Next</button></div></div></div></div>;
}
